import { useFormatter } from "@grandvisionhq/frk-routing";
import { useIntl } from "@grandvisionhq/state";
import { isDefined, getLocalizedValue, getProductKeyFromCTType } from "@grandvisionhq/utils";
const useFormatProductLinks = ({ products }) => {
  const formatter = useFormatter();
  const { locale } = useIntl();
  return products.filter(isDefined).map((product) => {
    const sku = product.masterVariant.sku ?? "";
    const slug = typeof product.slug === "string" ? product.slug : getLocalizedValue(product.slug, locale);
    const key = getProductKeyFromCTType(product?.productType ?? "");
    const link = formatter({
      route: "products.detail",
      params: { sku, slug, key }
    });
    return {
      link: typeof link === "string" ? link : "#",
      sku
    };
  });
};
export {
  useFormatProductLinks
};
//# sourceMappingURL=use-format-product-links.js.map
